import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pin_element",
  "use": "pin_element-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"pin_element\"><path d=\"M3.75 0h6.5A3.75 3.75 0 0114 3.75C14 4.44 13.44 5 12.75 5h-.25V3.75a2.25 2.25 0 00-2.25-2.25h-6.5A2.25 2.25 0 001.5 3.75v6.5a2.25 2.25 0 002.25 2.25H5v.25C5 13.44 4.44 14 3.75 14A3.75 3.75 0 010 10.25v-6.5A3.75 3.75 0 013.75 0z\" /><path d=\"M12.5 7.25a.75.75 0 011.5 0V14H7.25a.75.75 0 010-1.5h4.19L6.47 7.53l1.06-1.06 4.97 4.969V7.25z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol